
export function log(...args: any[]): void {
  const backgroundColor = "#00B9C3";
  const textColor = "#FFFFFF";
  console.log('%c Ibex: ', `background: ${backgroundColor}; color: ${textColor}`, ...args);
}
